<template>
    <internal>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <breeze-table :searchable="true" :fields="fields" :items="enquiries" :searchlink="route('internal.enquiry.search',branchid)" :canView="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Enquiry')">
                <template #date="data">
                    {{convertDate(data.item.created_at)}}
                </template>
                <template #student="data">
                    {{data.item.student.first_name}} {{data.item.student.last_name}}
                </template>
                <template #branch="data">
                    {{data.item.branch?.title}}
                </template>
                <template #duration="data">
                    {{data.item.academicyear?.start_month}} - {{data.item.academicyear?.end_month}}
                </template>
                <template #course="data">
                    {{data.item.course?.title}}
                </template>
                <template #year="data">
                    {{data.item.courseyear?.title}}
                </template>
                <template #action="data">
                    <button-link :href="route('internal.enquiry.edit',[branchid,data.item.id])" >View</button-link>
                </template>

            </breeze-table>
        </div>
    </internal>
</template>

<script>
    import Internal from '@/Pages/Internal/Internal'
    import BreezeTable from '@/Components/Table'
    import ButtonLink from '@/Components/ButtonLink'

    export default {
        components: {
            Internal,
            BreezeTable,
            ButtonLink
        },
        props:['enquiries'],
        data(){
            return{
                fields:[{'key':'date','label':'Date'},{'key':'student','label':'Student'},{'key':'branch','label':'Branch'},{'key':'duration','label':'Academic Duration'},{'key':'course','label':'Course'},{'key':'year','label':'Year'},{'key':'action','label':'Action'}],
                branchid:localStorage.branchId
            }
        }
    }
</script>
